import momentJalali from "moment-jalaali";

const objectUtil = {
  filter(obj, filter) {
      return Object.keys(obj)
          .filter(key => filter(key, obj[key]))
          .reduce((res, key) => (res[key] = obj[key], res), {});
  },
  map(obj, map) {
      return Object.keys(obj)
          .reduce((res, key) => (res[key] = map(key, obj[key]), res), {});
  },
  filterWithMap(obj, filter, map) {
      return Object.keys(obj)
          .filter(key => filter(key, obj[key]))
          .reduce((res, key) => (res[key] = map(key, obj[key]), res), {});
  },
  toFormData(obj) {
      var formData = new FormData();
      function appendFormData(data, root = '') {
          if (data instanceof File)
              formData.append(root, data);
          else if (Array.isArray(data) && data.length)
              for (var i = 0; i < data.length; i++)
                  appendFormData(data[i], root + '[' + i + ']');
          else if (Array.isArray(data))
              formData.append(root, '');
          else if (typeof data === 'object' && data)
              for (var key in data)
                  appendFormData(data[key], root === '' ? key : root + '[' + key + ']');
          else if (data == null)
              formData.append(root, '');
          else if (typeof data == 'boolean')
              formData.append(root, data ? 1 : 0);
          else if (typeof data !== 'undefined')
              formData.append(root, data);
      }
      appendFormData(obj);
      return formData;
  },
  toPrimitiveValues(obj) {
      let parseValue = (val) => {
          if (typeof val == 'undefined' || val == '')
            return null;
          else if (val === 'false' || val === 'true')
            return val === 'true';
          else if (Array.isArray(val))
            return val.map(val => parseValue(val));
          else if (typeof val === 'object' && val)
            return this.map(val, (key, val) => parseValue(val));
          else if (!isNaN(parseFloat(val)) && isFinite(val))
            return Number(val);
          else
            return val;
      }
      return parseValue(obj);
  }
};
const rbacUtil = {
  can(permission) {
      return useAuthStore().user.employee && useAuthStore().user.permissions.includes(permission);
  },
};
const sortUtil = {
  base(x, y) {
      if (!x && !y)
          return 0;
      if (!x)
          return 1;
      if (!y)
          return -1;
      return x > y ? 1 : (x < y ? -1 : 0);
  },
  date(x, y) {
      if (!x && !y)
          return 0;
      if (!x)
          return 1;
      if (!y)
          return -1;
      let xd = (new Date(x)).getTime();
      let yd = (new Date(y)).getTime();
      return xd > yd ? 1 : (xd < yd ? -1 : 0);
  },
};
const textUtil = {
  copy(text) {
      if(navigator.clipboard)
          navigator.clipboard.writeText(text).then(function () {
            useToastStore().success('کپی شد', 1000)
          });
  },
  substrTable(value, num) { return value ? `${value.substr(0,num)}${value.length > num ? '......' : ''}` : '' },
  toggleSelectAll(items, all, data, attr = 'id'){
      let item = data;
      for (let i = 0; i < items.split('.').length; i++) {
          item = item[items.split('.')[i]]
      }
      if(item.length != data[all].length){
          item.splice(0,item.length)
          item.push(...data[all].map(x => attr ? x[attr] : x))
      } else
          item.splice(0,item.length)
  },
};
const fileDownloadUtil = (data, filename, mime = 'application/octet-stream') => {
  let blob = new Blob([data], {type: mime});
  let blobURL = (window.URL && window.URL.createObjectURL) ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob);
  let tempLink = document.createElement('a');
  tempLink.style.display = 'none';
  tempLink.href = blobURL;
  tempLink.setAttribute('download', filename);
  document.body.appendChild(tempLink);
  tempLink.click();
  setTimeout(() => {
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobURL);
  }, 200)
}
const headTag = {
  add: (selector, tag, options) => {
    if (document == undefined)
      return;
    const element = document.querySelector(selector) || document.createElement(tag);
    for (const key in options)
      element.setAttribute(key, options[key]);
    if (!document.querySelector(selector))
      document.head.appendChild(element);
  },
  remove: (selector) => {
    if (document == undefined)
      return;
    const element = document.querySelector(selector);
    if (element)
      document.head.removeChild(element)
  }
}

export const useObject = () => {
  return objectUtil;
}
export const useRbac = () => {
  return rbacUtil;
}
export const useSort = () => {
  return sortUtil;
}
export const useText = () => {
  return textUtil;
}
export const useFileDownload = () => {
  return fileDownloadUtil;
}
export const useMoment = () => {
  return momentJalali;
}
export const useHeadTag = () => {
  return headTag;
}

export default {
  install: (app) => {
    app.config.globalProperties.$object = objectUtil;
    app.config.globalProperties.$rbac = rbacUtil;
    app.config.globalProperties.$sort = sortUtil;
    app.config.globalProperties.$text = textUtil;
    app.config.globalProperties.$fileDownload = fileDownloadUtil;
    app.config.globalProperties.$moment = momentJalali;
    app.config.globalProperties.$headTag = headTag;
    app.provide('object', objectUtil);
    app.provide('rbac', rbacUtil);
    app.provide('sort', sortUtil);
    app.provide('text', textUtil);
    app.provide('fileDownload', fileDownloadUtil);
    app.provide('moment', momentJalali);
    app.provide('headTag', headTag);
  }
}
